/** Class lists shared by the console screens (brand: antoja-marca skill). */

/**
 * Text inputs and selects. A field with an error gets a darker, thicker edge (no red:
 * brand rule), next to the message.
 */
const controlBase =
  'min-h-11 rounded-xl border border-field bg-surface text-[15px] font-normal text-ink placeholder:text-muted disabled:border-line disabled:bg-canvas disabled:text-muted aria-[invalid=true]:border-ink aria-[invalid=true]:ring-1 aria-[invalid=true]:ring-ink max-[799px]:text-base';

export const controlClass = `${controlBase} w-full px-3.5`;

/**
 * Selects add their own inner padding: 10 px lines their text up with the inputs.
 * No width here, so a toolbar select can size to its content (w-auto would lose to
 * w-full in Tailwind v4's ordering).
 */
export const selectBase = `${controlBase} pr-2 pl-2.5`;

export const selectClass = `${selectBase} w-full`;

/** A white card on the grey canvas. */
export const surfaceClass = 'rounded-2xl border border-line bg-surface';

/** Buttons, and links that look like one (open the menu). One primary per screen. */
export const buttonBase =
  'inline-flex min-h-11 items-center justify-center gap-2 rounded-xl text-[14.5px] whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-60 aria-disabled:cursor-not-allowed aria-disabled:opacity-60';
export const secondaryLook =
  'border border-line bg-surface px-4 font-medium text-ink hover:border-field dark:border-field';
